var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_152)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9528 10.6097C18.4734 8.46344 21.5266 8.46344 22.0472 10.6097C22.2057 11.2636 22.6669 11.8026 23.2886 12.0601C23.9102 12.3177 24.6175 12.2628 25.192 11.9126C27.0779 10.7637 29.2376 12.9221 28.0887 14.8092C27.7389 15.3835 27.6842 16.0902 27.9414 16.7115C28.1987 17.3327 28.737 17.7939 29.3903 17.9528C31.5366 18.4734 31.5366 21.5266 29.3903 22.0472C28.7364 22.2057 28.1974 22.6669 27.9399 23.2886C27.6823 23.9102 27.7372 24.6175 28.0874 25.192C29.2363 27.0779 27.0779 29.2376 25.1908 28.0887C24.6165 27.7389 23.9098 27.6842 23.2885 27.9414C22.6673 28.1987 22.2061 28.737 22.0472 29.3903C21.5266 31.5366 18.4734 31.5366 17.9528 29.3903C17.7943 28.7364 17.3331 28.1974 16.7114 27.9399C16.0898 27.6823 15.3825 27.7372 14.808 28.0874C12.9221 29.2363 10.7624 27.0779 11.9113 25.1908C12.2611 24.6165 12.3158 23.9098 12.0586 23.2885C11.8013 22.6673 11.263 22.2061 10.6097 22.0472C8.46344 21.5266 8.46344 18.4734 10.6097 17.9528C11.2636 17.7943 11.8026 17.3331 12.0601 16.7114C12.3177 16.0898 12.2628 15.3825 11.9126 14.808C10.7637 12.9221 12.9221 10.7624 14.8092 11.9113C16.0314 12.6544 17.6154 11.9969 17.9528 10.6097Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.17141a645535a1f7db0aa387b6275e2c.svg";
export { ForwardRef as ReactComponent };